<template>
  <router-link
    :to="{ name: destination }"
    class="add button is-large is-warning"
  >
    <span class="icon is-medium">
      <i class="fas fa-plus" />
    </span>
  </router-link>
</template>

<script>
export default {
  props: {
    destination: {
      required: true,
      type: String
    }
  }
};
</script>

<style scoped lang="scss">
.add {
  @include action-button();
}
</style>



// WEBPACK FOOTER //
// BaseRouterRoundButton.vue?c3542072